import { apiPost } from './api';
import { safeReviewUrl } from './reviewHtml';
import { normalizeReviewImageUrl } from './reviewImage';

// CKEditor uploads use the same authenticated, CSRF-protected API as review writes.
export const createReviewUploadPlugin = (csrfToken) => function ReviewUploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    const controller = new AbortController();
    return {
      async upload() {
        if (!csrfToken) throw new Error('인증 정보를 확인할 수 없습니다. 페이지를 새로고침해주세요.');
        const file = await loader.file;
        const payload = new FormData();
        payload.append('upload', file);
        const response = await apiPost('/review/ckeditor_upload.php', payload, {
          headers: { 'X-CSRF-Token': csrfToken },
          signal: controller.signal,
          onUploadProgress: (event) => {
            if (event.total) loader.uploadTotal = event.total;
            loader.uploaded = event.loaded;
          },
        });
        const url = safeReviewUrl(normalizeReviewImageUrl(response?.url || ''), true);
        if (!response?.uploaded || !url) throw new Error(response?.error?.message || '이미지 업로드에 실패했습니다.');
        return { default: url };
      },
      abort() { controller.abort(); },
    };
  };
};
